import type { Locale } from '@change-corgi/config/locales';

import { guideUrls } from './config';
import type { Guide } from './types';

export function getGuideUrl(locale: Locale, guide: Guide): string | undefined {
	return guideUrls[locale][guide];
}
